import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetPaymentTradesHistoryService } from "@/features/accounts/payment/scraping/services/get-trades-history-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetPaymentTradesHistoryResponseModel } from "@/features/accounts/payment/scraping/services/get-trades-history-model";

export const useGetPaymentTradesHistory = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getPaymentTradesHistoryService = new GetPaymentTradesHistoryService();

  // MoneyLook取込履歴取得
  const getPaymentTradesHistory = async (
    accountGroupId: string,
    paymentAccountId: string,
    paymentId: string,
    offset?: string,
  ): Promise<GetPaymentTradesHistoryResponseModel> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getPaymentTradesHistoryService.getPaymentTradesHistory({
        account_group_id: accountGroupId,
        payment_account_id: paymentAccountId,
        payment_id: paymentId,
        offset,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getPaymentTradesHistory:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getPaymentTradesHistory: errorHandledAsync(getPaymentTradesHistory, setError),
  };
};
